<template>
    <input type="text" name="address"  class="form-control reportInputs" :value="value" @input="updated($event.target.value)" @focus="geolocate()" autocomplete="off">
</template>

<style lang="scss">
    .pac-container {
        z-index: 2000;
    }
</style>

<script>
    export default {
        props: ['value'],
        data() {
            return {
                autocomplete: null,
                geolocationHasRun: false,
            };
        },
        mounted() {
            this.init();
        },
        methods: {

            updated(address) {
                this.$emit('input', address);
                this.$emit('change');
            },

            init() {

                if (google) {

                    let options = {
                        types: ['geocode'],
                    };

                    this.autocomplete = new google.maps.places.Autocomplete(this.$el, options);
                    this.autocomplete.setFields(['formatted_address', 'address_component', 'geometry']);
                    this.autocomplete.addListener('place_changed', this.autocompleteListener);

                }
            },

            autocompleteListener() {
                let place = this.autocomplete.getPlace();

                let address = [];   // Temporary array to build the address string
                let location = {
                    formatted: null,
                    coords: null,
                    components: { address: '', city: '', province: '', postal: '', country: '', county: '' }
                };
                let map = { locality: 'city', administrative_area_level_1: 'province', postal_code: 'postal', administrative_area_level_2: 'county', country: 'country'};

                location.formatted = (place.formatted_address ? place.formatted_address : null);

                if (place.geometry) {
                    location.coords = {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    };
                }

                place.address_components.forEach(component => {
                    for (let type of component.types) {
                        if (type === 'street_number') {
                            address[0] = component.long_name;
                            break;
                        } else if (type === 'route') {
                            address[1] = component.long_name;
                            break;
                        } else if (map.hasOwnProperty(type)) {
                            location.components[map[type]] = component.long_name;
                            break;
                        }
                    }
                });

                location.components.address = address.join(' ');

                this.$emit('location', location);
                this.updated(this.$el.value);

            },

            geolocate() {
                if ((navigator.geolocation) && (!this.geolocationHasRun)) {
                    this.geolocationHasRun = true;
                    navigator.geolocation.getCurrentPosition((position) => {
                        var geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        var circle = new google.maps.Circle({
                            center: geolocation,
                            radius: position.coords.accuracy
                        });
                        this.autocomplete.setBounds(circle.getBounds());
                    });
                }
            }

        },

    }
</script>

